/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Campaign } from './Campaign';
import {
    CampaignFromJSON,
    CampaignFromJSONTyped,
    CampaignToJSON,
    CampaignToJSONTyped,
} from './Campaign';

/**
 * The price model configuration for a specific cruise
 * @export
 * @interface PriceModelOffer
 */
export interface PriceModelOffer {
    /**
     * The code of the price model
     * @type {string}
     * @memberof PriceModelOffer
     */
    code?: string;
    /**
     * The name of the price model
     * @type {string}
     * @memberof PriceModelOffer
     */
    name?: string;
    /**
     * Boolean if specific cabin number is selectable
     * @type {boolean}
     * @memberof PriceModelOffer
     */
    cabinSelectable?: boolean;
    /**
     * Indicator that offer contains a flight as mandatory service
     * @type {boolean}
     * @memberof PriceModelOffer
     */
    mandatoryFlight?: boolean;
    /**
     * Information about current campaigns
     * @type {Array<Campaign>}
     * @memberof PriceModelOffer
     */
    campaigns?: Array<Campaign>;
}

/**
 * Check if a given object implements the PriceModelOffer interface.
 */
export function instanceOfPriceModelOffer(value: object): value is PriceModelOffer {
    return true;
}

export function PriceModelOfferFromJSON(json: any): PriceModelOffer {
    return PriceModelOfferFromJSONTyped(json, false);
}

export function PriceModelOfferFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceModelOffer {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
        'cabinSelectable': json['cabinSelectable'] == null ? undefined : json['cabinSelectable'],
        'mandatoryFlight': json['mandatoryFlight'] == null ? undefined : json['mandatoryFlight'],
        'campaigns': json['campaigns'] == null ? undefined : ((json['campaigns'] as Array<any>).map(CampaignFromJSON)),
    };
}

export function PriceModelOfferToJSON(json: any): PriceModelOffer {
    return PriceModelOfferToJSONTyped(json, false);
}

export function PriceModelOfferToJSONTyped(value?: PriceModelOffer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'cabinSelectable': value['cabinSelectable'],
        'mandatoryFlight': value['mandatoryFlight'],
        'campaigns': value['campaigns'] == null ? undefined : ((value['campaigns'] as Array<any>).map(CampaignToJSON)),
    };
}

